import React, { Component } from 'react';
import { configureStore } from './configureStore';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import Navigation from './navigation';
import setup, { loadIntegration } from './utils/setup';
import { GlobalInserts } from './_shared/styles';
import { Global } from '@emotion/react';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';
import { AppConfigProvider } from './_shared/hooks/useAppConfig';

export const { store, persistor } = configureStore();
setup();

Bugsnag.start({
  // SECURITY (AER-1639): set REACT_APP_BUGSNAG_API_KEY at CRA build time.
  // Bugsnag FE keys are notification keys meant to live in client code; the env
  // var only removes the literal from source control (it ships in the bundle).
  apiKey: process.env.REACT_APP_BUGSNAG_API_KEY || '',
  plugins: [new BugsnagPluginReact()],
});

//@ts-ignore
export const ErrorBoundary = Bugsnag.getPlugin('react').createErrorBoundary(React);

export default class App extends Component {
  componentDidMount(): void {
    loadIntegration(store);
  }
  render() {
    return (
      <ErrorBoundary>
        <Provider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            <Global styles={GlobalInserts} />
            <AppConfigProvider>
              {/* @ts-ignore: sState is injected by connect */}
              <Navigation />
            </AppConfigProvider>
          </PersistGate>
        </Provider>
      </ErrorBoundary>
    );
  }
}
